import ms from 'ms'

export const FINAL_ORDER_STATES = new Set(['failed', 'complete'])

export const FAIL_LIMIT = ms('4d')

// Buffer to allow extra time for the wallet to detect toTxs before failing an order
export const START_BUFFER = ms('2m')

export const V3_ORDER_FINISHED_STATUSES = new Set([
  'complete',
  'expired',
  'failed',
  'refunded',
  'swapped',
])

export const ORDER_STATUS_UPDATE_STRATEGY = {
  CLIENT_AND_SERVER: 'CLIENT_AND_SERVER',
  CLIENT_OR_SERVER: 'CLIENT_OR_SERVER',
}
